import type { LivestreamGuessResult } from "./types";

type LivestreamResultFlashProps = {
  result: LivestreamGuessResult | null;
};

export function LivestreamResultFlash({ result }: LivestreamResultFlashProps) {
  if (!result) {
    return null;
  }

  return (
    <div
      className={
        result.is_correct
          ? "livestream-result livestream-result--correct"
          : "livestream-result livestream-result--wrong"
      }
      role="status"
    >
      <span>{result.is_correct ? "MATCHED" : "MODEL CHOSE"}</span>
      <strong>{result.is_correct ? result.target_san : result.target_move}</strong>
    </div>
  );
}

